/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetSelfEmploymentResponse
 */
export interface AssetSelfEmploymentResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AssetSelfEmploymentResponse
     */
    hasSelfEmploymentIncome: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSelfEmploymentResponse
     */
    description: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetSelfEmploymentResponse
     */
    monthlyIncome: number | null;
}

/**
 * Check if a given object implements the AssetSelfEmploymentResponse interface.
 */
export function instanceOfAssetSelfEmploymentResponse(value: object): value is AssetSelfEmploymentResponse {
    if (!('hasSelfEmploymentIncome' in value) || value['hasSelfEmploymentIncome'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('monthlyIncome' in value) || value['monthlyIncome'] === undefined) return false;
    return true;
}

export function AssetSelfEmploymentResponseFromJSON(json: any): AssetSelfEmploymentResponse {
    return AssetSelfEmploymentResponseFromJSONTyped(json, false);
}

export function AssetSelfEmploymentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetSelfEmploymentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'hasSelfEmploymentIncome': json['hasSelfEmploymentIncome'],
        'description': json['description'],
        'monthlyIncome': json['monthlyIncome'],
    };
}

export function AssetSelfEmploymentResponseToJSON(json: any): AssetSelfEmploymentResponse {
    return AssetSelfEmploymentResponseToJSONTyped(json, false);
}

export function AssetSelfEmploymentResponseToJSONTyped(value?: AssetSelfEmploymentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasSelfEmploymentIncome': value['hasSelfEmploymentIncome'],
        'description': value['description'],
        'monthlyIncome': value['monthlyIncome'],
    };
}

